import { useMutation, useQueryClient } from '@tanstack/react-query';
import { post } from '@truefit/http-utils';
import { useSnackbar } from 'notistack';
import { EMAIL_CONFIG_QUERY_KEY, type DispatchEmailConfig } from './useDispatchEmailConfigQuery';

export const useCreateDispatchEmailConfigMutation = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async (data: { address: string; label?: string }) => {
      const res = await post<DispatchEmailConfig>('/v1.0/clip-dispatch/email', data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: EMAIL_CONFIG_QUERY_KEY });
      enqueueSnackbar('Email address added', { variant: 'success' });
    },
    onError: (error: any) => {
      enqueueSnackbar(error?.response?.data?.error || 'Failed to add email', { variant: 'error' });
    },
  });
};
